import type { AccessLevel, ModuleKey, User } from '../types/api';

/**
 * Ordered module list with Ukrainian labels — mirrors apps/core/modules.py.
 *
 * `short` — для чипів у таблиці користувачів: повні назви там не вміщаються
 * і рвуть рядок, тож у макеті стоять скорочення.
 */
export const MODULES: { key: ModuleKey; label: string; short: string; hint: string }[] = [
  {
    key: 'purchases',
    label: 'Закупівля деревини',
    short: 'Закупівля',
    hint: 'Закупівлі сирої та сухої деревини',
  },
  {
    key: 'production',
    label: 'Виробництво',
    short: 'Виробництво',
    hint: 'Сушіння, переробка, виробничі записи',
  },
  { key: 'stock', label: 'Склад підприємства', short: 'Склад', hint: 'Залишки по складах' },
  {
    key: 'references',
    label: 'Номенклатура',
    short: 'Номенклатура',
    hint: 'Довідники та норми виробів',
  },
  {
    key: 'marketing',
    label: 'Маркетинг',
    short: 'Маркетинг',
    hint: 'Замовлення, відвантаження, рекламації',
  },
  { key: 'reports', label: 'Звіти / Дашборд', short: 'Звіти', hint: 'Дашборд і звіти' },
  {
    key: 'invoices',
    label: 'Рахунки до оплати',
    short: 'Рахунки',
    hint: 'Реєстр рахунків, погодження, оплати',
  },
];

/** Effective access level for a module: admins implicitly have 'edit' everywhere. */
function accessLevel(user: User | null, module: ModuleKey): AccessLevel | null {
  if (!user) return null;
  if (user.is_admin) return 'edit';
  return user.module_access?.[module] ?? null;
}

/** Whether the user may open/read a module. */
export function canView(user: User | null, module: ModuleKey): boolean {
  return accessLevel(user, module) !== null;
}

/** Whether the user may CHANGE things in a module, not just look at them. */
export function canEdit(user: User | null, module: ModuleKey): boolean {
  return accessLevel(user, module) === 'edit';
}
